export default {
  blik__title: 'Завершіть оплату переказом BLIK',
  blik__intro: 'Щоб завершити оплату, зробіть переказ на номер телефону нижче.',

  blik__phone_label: 'Зробіть переказ на цей номер',
  blik__full_name_label: 'Ім\'я та прізвище отримувача',
  blik__amount_label: 'Сума переказу',
  blik__time_remaining: 'Час, що залишився',

  blik__step_1: 'Відкрийте банківський застосунок (або інтернет-банк).',
  blik__step_2: 'Оберіть переказ на номер телефону (BLIK P2P).',
  blik__step_3: 'Введіть номер телефону: <b>{customer_phone}</b>',
  blik__step_4: 'Переконайтеся, що ім\'я та прізвище отримувача збігаються. Якщо поле не є обов\'язковим — пропустіть цей крок.',
  blik__step_5: 'Введіть суму: <b>{amount} {currency}</b>',
  blik__step_6: 'Підтвердіть переказ і поверніться на цю сторінку.',

  blik__after_transfer:
    'Після виконання переказу статус платежу оновиться автоматично. Це може зайняти трохи часу.',

  blik__info_banner: 'Зробіть переказ у банківському застосунку, щоб підтвердити платіж.',

  blik__btn_confirm: 'Я зробив(ла) переказ',
  blik__btn_cancel: 'Скасувати і повернутись',

  blik__note_1: 'Якщо ви не зробите переказ, платіж не буде підтверджено.',
  blik__note_2: 'Якщо інструкція закінчиться (якщо показано), створіть новий платіж і спробуйте ще раз.',
};
